"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongProeprtiesPanel = void 0;
const ITabNavigator_1 = require("../../core/render/ITabNavigator");
const HTMLWidgetFormBuilder_1 = require("../../core/render/HTMLWidgetFormBuilder");
const AccordionWidget_1 = require("../widgets/AccordionWidget");
const CardGridWidget_1 = require("../widgets/CardGridWidget");
const BrowseResourceModalDialogBox_1 = require("../modalDialogBoxes/BrowseResourceModalDialogBox");
const Resource_1 = require("../../core/resourceSystem/Resource");
class SongProeprtiesPanel {
    constructor(viewModel) {
        this.viewModel = viewModel;
        this.supportedPluginComponents = [];
        this.pluginsAdded = [];
        this.formData = {};
        this.formData.main = {};
        this.accordionSections = [];
        this.editComponents = [];
        for (let notLoadedPlugin of viewModel.plugins.filter(plugin => viewModel.loadedPlugins.map(pluginObj => pluginObj.pluginName).includes(plugin.pluginName) === false)) {
            if (notLoadedPlugin.useNewSongForm) {
                this.supportedPluginComponents.push(notLoadedPlugin.getNewSongFormComponent());
            }
        }
    }
    get panelName() { return "Song Properties"; }
    get panelId() { return "songPropertiesPanel"; }
    get basePlugin() { return null; }
    renderContent(content, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tabNavigator = new ITabNavigator_1.TabNavigator();
            content.createElement("h1", h1 => h1.textContent = `Song Properties for ${this.song.name}`);
            let form = content.createElement("form", parentDiv => { });
            let browseModalDialog = new BrowseResourceModalDialogBox_1.BrowseResourceModalDialogBox(this.viewModel.resourceManager, form.element);
            let tabContainer = form.createElement("div", div => {
                div.classList.add("tab-horizontal-container");
                this.tabNavigator.parentContainer = div;
            });
            tabContainer.createElement("div", div => {
                let menuDiv = div;
                menuDiv.classList.add("tab-horizontal");
                this.tabNavigator.menuDiv = menuDiv;
                this.tabNavigator.buttonClassName = "tablinks-song-properties";
                this.tabNavigator.panelClassName = "tabcontent-horizontal";
            });
            let mainPanel = this.addTab("Main", "main", true, null);
            let pluginsUsedPanel = this.addTab("Plugins Used", "pluginsUsed", false, null);
            this.setupPluginsUsedPanel(pluginsUsedPanel);
            this.addPluginTabItems();
            mainPanel.renderBody.classList.add("form-container");
            let accordion = new AccordionWidget_1.AccordionWidget();
            accordion.accordionAdded = (section) => this.accordionSections.push(section);
            mainPanel.renderBody.appendChild(accordion.renderBody);
            let editSongAccordionPanel = accordion.addAccordionSection("Edit Song", true, null);
            let formBuilder = new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(editSongAccordionPanel.panel, true);
            formBuilder.addTextInput("Song Name", "songNameInput", true, input => input.value = this.song.name)
                .addTextInput("Artist", "artistInput", true, input => input.value = this.song.artist)
                .addUrlInput("URL To Song Image", "songImageInput", false, input => input.value = this.song.bannerImageUrl)
                .addElement("div", div => {
                div.classList.add("admon-warning");
                div.textContent =
                    "WARNING: the image will be resized to fit the banner width. Any image size is allowed.";
            })
                .addResourceInput("Audio Resource", "urlInput", true, (input) => {
                browseModalDialog.showDialog();
            }, input => {
                browseModalDialog.valueSelected = (type, resourceId, name) => {
                    this.formData.main.audioResourceId = resourceId;
                    input.value = `${Resource_1.ResourceType[type]}: ${name}`;
                };
                if (this.viewModel.audioResourceExists()) {
                    this.formData.main.audioResourceId = this.viewModel.getAudioResourceId();
                    input.value = `${Resource_1.ResourceType[this.viewModel.getAudioResourceType()]}: ${this.viewModel.getAudioResourceName()}`;
                }
            });
            let cardGrid = new CardGridWidget_1.CardGridWidget();
            mainPanel.renderBody.appendChild(cardGrid.renderBody);
            this.renderCards(cardGrid, accordion);
            form.createElement("button", button => {
                button.classList.add("btn");
                button.classList.add("btn-submit");
                button.style.marginTop = "10px";
                button.textContent = "Update Song";
                button.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
                    if (!form.renderBody.checkValidity()) {
                        alert("Form not valid.");
                        return;
                    }
                    this.formData.main.songName = mainPanel.element.querySelector("div #songNameInput").value;
                    this.formData.main.artist = mainPanel.element.querySelector("div #artistInput").value;
                    this.formData.main.songImageUrl =
                        mainPanel.element.querySelector("div #songImageInput").value;
                    this.formData.main.audioStreamUrl = mainPanel.element.querySelector("div #urlInput").value;
                    this.populateFormData(accordion);
                    this.populateFormDataAcrossTabs();
                    yield this.viewModel.updateSong(this.pluginsAdded, this.editComponents, this.formData);
                }));
            });
        });
    }
    setupPluginsUsedPanel(panel) {
        panel.createElement("p", p => p.textContent =
            "The following plugins have been loaded for this song. You can disable or remove plugins here.");
        panel.createElement("div", div => {
            div.classList.add("admon-warning");
            div.textContent = "WARNING: Any actions issued in this tab will automatically refresh the page.";
        });
        panel.createElement("table", element => {
            let table = element;
            table.innerHTML = `
<thead>
<tr>
    <th>Name</th>
    <th>Friendly Name</th>
    <th>Actions</th>
</tr>
</thead>
`;
            let body = table.createTBody();
            for (let loadedPlugin of this.viewModel.loadedPlugins) {
                let row = body.insertRow();
                let nameCell = row.insertCell();
                nameCell.textContent = loadedPlugin.pluginName;
                let friendlyNameCell = row.insertCell();
                friendlyNameCell.textContent = loadedPlugin.friendlyPluginName;
                let actionCell = row.insertCell();
                this.insertPluginActions(actionCell, loadedPlugin.pluginName);
            }
        });
    }
    insertListAnchor(parent) {
        let listItem = document.createElement("li");
        let anchor = document.createElement("a");
        listItem.appendChild(anchor);
        parent.appendChild(anchor);
        return anchor;
    }
    insertPluginActions(actionCell, pluginName) {
        let list = document.createElement("ul");
        list.classList.add("table-list");
        let removeAction = this.insertListAnchor(list);
        removeAction.textContent = "Remove Plugin";
        removeAction.href = "#";
        removeAction.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
            evt.preventDefault();
            if (confirm(`Are you sure you want to remove plugin "${pluginName}"? All associated plugin data for this song will be deleted.`)) {
                yield this.viewModel.removePlugin(pluginName);
            }
            return false;
        }));
        actionCell.appendChild(list);
    }
    addTab(tabName, tabId, defaultTab, component) {
        return this.tabNavigator.addTabMenuItem(tabName, tabId, defaultTab, component);
    }
    addPluginTabItems() {
        for (let plugin of this.viewModel.loadedPlugins) {
            if (plugin.useNewSongForm) {
                let editSongTabItem = plugin.getEditSongFormComponent();
                if (editSongTabItem != null) {
                    let pluginTab = this.addTab(editSongTabItem.basePlugin.friendlyPluginName, editSongTabItem.basePlugin.pluginName, false, editSongTabItem);
                    editSongTabItem.addEditSongForm(new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(pluginTab, true), this.viewModel.getSongMetadataForPlugin(editSongTabItem.basePlugin.pluginName));
                    this.editComponents.push(editSongTabItem);
                    this.formData[editSongTabItem.basePlugin.pluginName] = {};
                }
            }
        }
    }
    populateFormData(accordion) {
        for (let section of this.accordionSections) {
            if (section.additionalData != null) {
                let inputs = section.panel.renderBody.querySelectorAll(".row .col-75 .input-search");
                for (let j = 0; j < inputs.length; j++) {
                    let inputElement = inputs[j];
                    this.formData[section.additionalData.basePlugin.pluginName][inputElement.id] = inputElement.value;
                }
            }
        }
    }
    populateFormDataAcrossTabs() {
        for (let tab of this.tabNavigator.tabs) {
            if (tab.additionalData != null) {
                let inputs = tab.tabPanel.element.querySelectorAll(".input-search");
                for (let j = 0; j < inputs.length; j++) {
                    let inputElement = inputs[j];
                    this.formData[tab.additionalData.basePlugin.pluginName][inputElement.id] = inputElement.value;
                }
            }
        }
    }
    addCard(cardGrid, accordionWidget, component, appendChild = false) {
        var _a;
        cardGrid.addCard(component.basePlugin.friendlyPluginName, (_a = component.basePlugin.description) !== null && _a !== void 0 ? _a : "No Description has been provided for this plugin.", appendChild, (card) => {
            let section = accordionWidget.addAccordionSection(component.basePlugin.pluginName, true, component);
            let panel = section.panel;
            panel.createElement("button", button => {
                button.textContent = "Remove";
                button.classList.add("btn");
                button.addEventListener("click", () => {
                    accordionWidget.removeAccordionSection(panel);
                    this.accordionSections.splice(this.accordionSections.indexOf(section), 1);
                    this.pluginsAdded.splice(this.pluginsAdded.indexOf(component), 1);
                    this.formData[component.basePlugin.pluginName] = null;
                    this.addCard(cardGrid, accordionWidget, component, true);
                });
            });
            component.addForm(new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(panel, true));
            this.formData[component.basePlugin.pluginName] = {};
            this.pluginsAdded.push(component);
            cardGrid.renderBody.removeChild(card);
        });
    }
    renderCards(cardGrid, accordionDiv) {
        for (let component of this.supportedPluginComponents) {
            this.addCard(cardGrid, accordionDiv, component, true);
        }
    }
}
exports.SongProeprtiesPanel = SongProeprtiesPanel;
//# sourceMappingURL=SongPropertiesPanel.js.map